export default class AttemptInquirer {
    attempts;
    timeout;
    attempt = 1;
    completeCallback = () => {};

    constructor(
        attempts = 10,
        timeout = 2000,
    ) {
        this.attempts = attempts;
        this.timeout = timeout;
    }

    run(callback) {
        this.attempt = 1;
        this.#doRun(callback);
    }

    onComplete(completeCallback) {
        this.completeCallback = completeCallback;
    }

    #doRun(callback) {
        if (this.attempt >= this.attempts) {
            this.completeCallback();
            return;
        }

        this.attempt++;

        setTimeout(() => {
            callback(
                //  continue/proceed
                () => {
                    this.#doRun(callback);
                },
            );
        }, this.timeout);
    }
};
